export const TERM_TYPES = {
    HASHTAG: 'hashtag',
    KEYWORD: 'keyword',
};

export const DECORATION_BY_TERM_TYPE = {
    [TERM_TYPES.HASHTAG]: { before: '#', after: null },
    [TERM_TYPES.KEYWORD]: { before: '“', after: '”' },
};
